(function () {
    'use strict';

    function searchConfigurationContent() {
        return {
            restrict: 'E',
            scope: true,
            templateUrl: 'siteConfiguration/directives/templates/searchConfigurationContent.html',
            link: function (scope, element, attrs) {
                scope.searchFieldsProperty = attrs.searchFieldsProperty;
            }
        };
    }

    searchConfigurationContent.$inject = [];

    angular.module('ecap.siteConfiguration').directive('searchConfigurationContent', searchConfigurationContent);
})();

